import { IconType } from 'components/DesignSystem/Icon/icons';

export type ProductEntry = {
  name: string;
  link: string;
  icon: IconType;
  id: string;
};

export const homeProducts = [
  {
    name: 'Meus Arquivos', link: '/fileviewer', icon: 'archives', id: 'files',
  },
  {
    name: 'Meteorologia', link: '/meteorology', icon: 'meteorology', id: 'meteorology',
  },
  {
    name: 'Flux', link: '/flux', icon: 'flux', id: 'flux',
  },
] as ProductEntry[];
